/** Local display identity, excluded from all canonical physics/editor projections. */
import type { Node } from "reactflow";
const KEY = "eoCanvasNodeIncarnation";
let serial = 0;
const session = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
type IncarnatedNode = Node & { readonly eoCanvasNodeIncarnation?: string };

export function canvasNodeIncarnation(node: Pick<Node, "id" | "type">): string | null {
  const value = (node as Pick<IncarnatedNode, "id" | "type" | "eoCanvasNodeIncarnation">)[KEY];
  return typeof value === "string" && value.length <= 128 ? value : null;
}
export function newCanvasNodeIncarnation<T extends Node>(node: T): T {
  return { ...node, [KEY]: `${session}:${++serial}` };
}
/** Existing edit objects carry their identity; genuinely new/replacement rows receive a new one. */
export function ensureCanvasNodeIncarnations<T extends Node>(nodes: readonly T[]): T[] {
  return nodes.map(node => canvasNodeIncarnation(node) === null ? newCanvasNodeIncarnation(node) : node);
}
